//表单验证用户名
const checkAccount = (rule, value, callback) => {
	if (!value) {
		return callback(new Error('用户名不能为空'))
	} else {
		const reg = /^[a-z_\d]{4,16}$/
		if (reg.test(value)) {
			callback()
		} else {
			return callback(new Error('由4-16位字母、数字、下划线组成'))
		}
	}
}
//表单验证微信号
const checkWechat = (rule, value, callback) => {
	if (value === '') {
		callback()
		return
	}
	const reg = /^[a-zA-Z_\d]{6,20}$/
	if (reg.test(value)) {
		callback()
	} else {
		return callback(new Error('由6-20位字母、数字、下划线组成'))
	}
}
const checkPassword = (rule, value, callback) => {
	if (value === '') {
		callback()
		return
	}
	const reg = /^[a-zA-Z_\d]{6,20}$/
	if (reg.test(value)) {
		callback()
	} else {
		return callback(new Error('由6-20位字母、数字、下划线组成'))
	}
}
//表单验证手机号
const checkPhone = (rule, value, callback) => {
	if (!value) {
		return callback(new Error('手机号不能为空'))
	} else {
		const reg = /1[3456789]{1}\d{9}$/
		if (reg.test(value)) {
			callback()
		} else {
			return callback(new Error('请输入正确的手机号'))
		}
	}
}

//表单验证身份证号
const checkIdcard = (rule, value, callback) => {
	if (!value) {
		return callback(new Error('身份证号不能为空'))
	} else {
		// 大陆身份证号码（一代）
		const oldReg = /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/
		// 大陆身份证号码（二代）
		const reg =
			/(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/;
		// 香港身份证号
		const hkRegEN = /^[A-Z]\d{6}\([\dA]\)$/;
		const hkRegCN = /^[A-Z]\d{6}（[\dA]）$/;
		// 澳门身份证号码校验
		// 开头数字1或者5或者7，然后接上6位数字，再接上一位数字或者大写字母校验
		const aoMenReg = /^[1|5|7][0-9]{6}[0-9A-Z]$/;
		// 台湾身份证号码校验
		// 开头一位小写或者大写字母，接上9位数字
		const taiWanReg = /^[a-zA-Z][0-9]{9}$/;
		// 香港不带开头字母
		const hkRegEN2 = /^\d{7}\([\dA]\)$/;
		const hkRegCN2 = /^\d{7}（[\dA]）$/;
		// 港澳居民来往内地通行证
		const HMReg = /^[H|h|M|m](\d{8}|\d{10})$/;
		// 护照规则： 14/15开头 + 7位数字, G + 8位数字, P + 7位数字, S/D + 7或8位数字,等
		const passportReg = /^([a-zA-z]|[0-9]){5,17}$/;
		if (reg.test(value)) {
			callback()
		} else if (oldReg.test(value)) {
			callback()
		} else if (hkRegEN.test(value)) {
			callback()
		} else if (hkRegCN.test(value)) {
			callback()
		} else if (aoMenReg.test(value)) {
			callback()
		} else if (taiWanReg.test(value)) {
			callback()
		} else if (hkRegEN2.test(value)) {
			callback()
		} else if (hkRegCN2.test(value)) {
			callback()
		} else if (HMReg.test(value)) {
			callback()
		} else if (passportReg.test(value)) {
			callback()
		} else {
			return callback(new Error('请输入正确的身份证号'))
		}
	}
}

//表单验证空字符串
const checkEmpty = (rule, value, callback) => {
	if ('' === value.toString().trim()) {
		return callback(new Error('请填写合法字符'))
	}
	callback()
}
//表单验证非负
const checkPositive = (rule, value, callback) => {
	if (Number(value) > 0) {
		callback()
	} else {
		return callback(new Error('请输入非负正正数'))
	}
}
//表单验证非负
const checkPositiveZ = (rule, value, callback) => {
	if (Number(value) >= 0) {
		callback()
	} else {
		return callback(new Error('请输入非负正正数'))
	}
}
export default {
	checkAccount,
	checkWechat,
	checkPhone,
	checkEmpty,
	checkPositive,
	checkPositiveZ,
	checkPassword,
	checkIdcard
}
